/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'service',
	title: 'Service',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'slug',
			title: 'Slug',
			type: 'slug',
			options: {
				source: 'title',
				maxLength: 96,
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'description',
			title: 'Description (Short Description)',
			type: 'text',
		},
		{
			name: 'content',
			title: 'Service Content (Long Description)',
			description:
				'Full description of the service with rich text. Use shift+enter for line breaks.',
			type: 'array',
			of: [
				{ type: 'block' },
				{
					type: 'image',
					options: { hotspot: true },
				},
			],
		},
		{
			name: 'benefits',
			title: 'Benefits',
			type: 'array',
			of: [
				{
					type: 'object',
					name: 'benefit',
					fields: [
						{
							name: 'title',
							title: 'Title',
							type: 'string',
							validation: (Rule: any) => Rule.required(),
						},
						{
							name: 'description',
							title: 'Description',
							type: 'text',
							validation: (Rule: any) => Rule.required(),
						},
					],
				},
			],
		},
		{
			name: 'image',
			title: 'Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
		{
			name: 'frequency',
			title: 'Frequency',
			type: 'string',
		},
		{
			name: 'location',
			title: 'Location',
			type: 'string',
		},
		{
			name: 'duration',
			title: 'Duration',
			description: 'Put 0 for tailored duration',
			type: 'number',
		},
		{
			name: 'format',
			title: 'Format (Hours/Minutes)',
			type: 'string',
			options: {
				list: [
					{ title: 'Hour', value: 'Hour' },
					{ title: 'Hours', value: 'Hours' },
					{ title: 'Minutes', value: 'Minutes' },
				],
				default: 'Hour',
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'isPOA',
			title: 'Price on Consultation',
			type: 'boolean',
			initialValue: false,
		},
		{
			name: 'price',
			title: 'Price',
			type: 'number',
		},
		{
			name: 'isPerHour',
			title: 'Is Price Per Hour',
			type: 'boolean',
			initialValue: false,
			hidden: ({ parent }) => parent?.isPOA,
		},
		{
			name: 'inPersonPrice',
			title: 'Has In Person Price',
			type: 'boolean',
			initialValue: false,
			hidden: ({ parent }) => parent?.isPOA,
		},
		{
			name: 'inPersonPriceValue',
			title: 'In Person Price',
			type: 'number',
			hidden: ({ parent }) => !parent?.inPersonPrice || parent?.isPOA,
		},
		{
			name: 'requiresConsultation',
			title: 'Requires Consultation',
			description:
				'Enable if this service is a consultation service or requires consultation with a starting price',
			type: 'boolean',
			initialValue: false,
		},
		{
			name: 'consultationPrice',
			title: 'Starting Price (From)',
			description:
				'Use format like "From 1000" for services that require consultation',
			type: 'number',
			hidden: ({ parent }) => !parent?.requiresConsultation,
		},
		{
			name: 'isBookable',
			title: 'Is Bookable',
			type: 'boolean',
			description:
				'Controls if this service can be booked. Overrides global settings.',
			initialValue: true,
		},
		{
			name: 'bookingStartDate',
			title: 'Booking Start Date',
			type: 'date',
			description:
				'Set a start date for new bookings for this service. All dates before this will be disabled.',
			options: {
				dateFormat: 'YYYY-MM-DD',
			},
			hidden: ({ parent }) => !parent?.isBookable,
		},

		{
			name: 'category',
			title: 'Category',
			type: 'reference',
			to: [{ type: 'serviceCategory' }],
		},
		{
			name: 'isFeatured',
			title: 'Featured in Homepage',
			type: 'boolean',
			initialValue: false,
		},
		{
			name: 'workbook',
			title: 'Workbook',
			type: 'file',
			options: {
				storeOriginalFilename: true,
			},
		},
	],
	preview: {
		select: {
			title: 'title',
			category: 'category.name',
			media: 'image',
		},
		prepare({ title, category, media }) {
			return {
				title,
				subtitle: category ? `Category: ${category}` : 'No category',
				media,
			};
		},
	},
};
